import React from 'react';
import Select from "react-select";

const InventoryCalculatorFilters = ({
    inventoryData,
    filter,
    itemSearchTerm,
    groupSearchTerm,
    setItemSearchTerm,
    setGroupSearchTerm,
    handleFilterChange,
    handleSave,
    handleOpeningClick,
    handleReceivedClick,
    handleWastageClick,
    handlePhysicalClick,
    allZero,
    hasPhysical,
    selectStyles,
    areAllCountsEmpty,
}) => {
    return (
        <div className="mt-4 flex items-center justify-between text-sm">
            <div className='w-[19rem] z-50'>
                <Select
                    className="react-select-container w-full"
                    classNamePrefix="react-select"
                    options={
                        inventoryData?.summary && Object.keys(inventoryData.summary).length > 0
                            ? Object.entries(inventoryData.summary)
                                .filter(([category]) => category.toLowerCase() === filter)
                                .flatMap(([, groups]) =>
                                    Object.entries(groups).flatMap(([, items]) =>
                                        items.map(item => ({ value: item.name, label: item.name }))
                                    )
                                )
                                .filter((option, index, self) =>
                                    index === self.findIndex(t => t.value === option.value)
                                )
                            : []
                    }
                    isClearable
                    isSearchable
                    placeholder="Search item..."
                    onChange={(selectedOption) => setItemSearchTerm(selectedOption?.value || "")}
                    styles={selectStyles}
                />
            </div>

            <div className='flex items-center space-x-4'>
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="filter"
                        value="food"
                        checked={filter === 'food'}
                        onChange={() => handleFilterChange('food')}
                        className='cursor-pointer'
                    />
                    <span>Food</span>
                </label>

                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        name="filter"
                        value="beverage"
                        checked={filter === 'beverage'}
                        onChange={() => handleFilterChange('beverage')}
                        className='cursor-pointer'
                    />
                    <span>Beverage</span>
                </label>
            </div>

            <div className='w-64 z-50'>
                <Select
                    className="react-select-container w-full"
                    classNamePrefix="react-select"
                    options={
                        inventoryData?.summary && Object.entries(inventoryData.summary).length > 0
                            ? Object.entries(inventoryData.summary)
                                .filter(([category]) => category.toLowerCase() === filter)
                                .flatMap(([, groups]) =>
                                    Object.keys(groups).map(groupName => ({
                                        value: groupName,
                                        label: groupName,
                                    }))
                                )
                                .filter((option, index, self) =>
                                    index === self.findIndex(t => t.value === option.value)
                                )
                            : []
                    }
                    isClearable
                    isSearchable
                    placeholder="Search group..."
                    onChange={(selectedOption) => setGroupSearchTerm(selectedOption?.value || "")}
                    styles={selectStyles}
                />
            </div>

            <div className="flex gap-2 items-center">
                <button
                    disabled={!inventoryData?.summary || allZero || areAllCountsEmpty()}
                    onClick={handleSave}
                    className="px-3 py-1.5 rounded-md font-medium bg-sky-100 text-sky-800 border border-sky-200 hover:bg-sky-200 hover:shadow-md text-sm transition disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:hover:bg-gray-100 disabled:hover:shadow-none disabled:cursor-not-allowed"
                >
                    Save
                </button>

                <button
                    onClick={handleOpeningClick}
                    disabled={hasPhysical}
                    className="px-3 py-1.5 rounded-md font-medium bg-sky-100 text-sky-800 border border-sky-200 hover:bg-sky-200 hover:shadow-md text-sm transition disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:hover:bg-gray-100 disabled:hover:shadow-none disabled:cursor-not-allowed"
                >
                    Add Opening
                </button>

                {/* <button
                    onClick={handleReceivedClick}
                    className="px-3 py-1.5 rounded-md font-medium bg-sky-100 text-sky-800 border border-sky-200 hover:bg-sky-200 hover:shadow-md text-sm transition"
                >
                    Receive Stocks
                </button> */}


                <button
                    onClick={handleWastageClick}
                    className="px-3 py-1.5 rounded-md font-medium bg-sky-100 text-sky-800 border border-sky-200 hover:bg-sky-200 hover:shadow-md text-sm transition"
                >
                    Wastage
                </button>

                <button
                    onClick={handlePhysicalClick}
                    disabled={allZero}
                    className="px-3 py-1.5 rounded-md font-medium bg-sky-100 text-sky-800 border border-sky-200 hover:bg-sky-200 hover:shadow-md text-sm transition disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:hover:bg-gray-100 disabled:hover:shadow-none disabled:cursor-not-allowed"
                >
                    Add Closing
                </button>
            </div>
        </div>
    )
}

export default InventoryCalculatorFilters